import React, { useState } from 'react';
import CurrentUser from './CurrentUser';
import TopNav from "./TopNav";
import { Container, Navbar, Nav, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Navmenu = () => {

  const [isActive, setActive] = useState("false");
  const handleToggle = () => {
    setActive(!isActive);
  };

  return (
    <Row>
      <TopNav />
      <Navbar expand="md" variant="light" className='sec-nav py-0' fixed='sticky-top'>
        <Container fluid>
          <div className="navbar-header d-block d-md-none" data-target="#secNavigation" data-toggle="collapse">
            <a className="toggle-brand navbar-toggle collapsed mb-2 m-0" href="/"><img src="/images/Clearpoint-Logo@3x.png" alt="Clearpoint Logo"/></a>
          </div>
          <button
            data-toggle="collapse" 
            data-target="#secNavigation" 
            aria-controls="#secNavigation" 
            className='navbar-toggler btn d-block d-md-none me-3 mb-2'
            onClick={handleToggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div id='secNavigation' className={isActive ? "collapse navbar-collapse" : null}>
            <ul className='navbar-nav py-0'>
              <li className="ml nav-item contracts">
                <Link to="/contracts" class="nav-link">
                    <img src="/images/ClearPoint_Member_Portal_CP-Contracts.png" alt="" />
                    Contract Information
                </Link>
              </li>
              <li className="ml nav-item document-upload">
                <Link to="/document-upload" class="nav-link">
                  <img src="/images/ClearPoint_Member_Portal_CP-Contracts.png" alt="" />
                    Document Upload
                </Link>
              </li>
              <li className="ml nav-item reports">
                <Link to="/reports" class="nav-link">
                  <img src="/images/ClearPoint_Member_Portal_CP-Reports.png" alt="" />
                  Reports
                </Link>
              </li>
              <li className="ml nav-item form-library">
                <Link to="/library" class="nav-link">
                <img src="/images/ClearPoint_Member_Portal_CP-Contracts.png" alt="" />
                  Library
                </Link>
              </li>
              <li className="ml nav-item trust">
                <Nav.Link 
                  href="https://clientpoint.fisglobal.com/tdcb/main/UserLogon?bankNumber=r9&amp;subProduct"
                  target={"_blank"}
                  >
                    <img src="/images/ClearPoint_Member_Portal_CP-Trust-Accounts.png" alt="" />
                    Account Access
                </Nav.Link>
              </li>
              <li className="ml nav-item customer">
                <Link to="/customer/profile" class="nav-link">
                  <img src="/images/ClearPoint_Member_Portal_CP-Customer.png" alt="" />
                  Customer Profile
                </Link>
              </li>
              <CurrentUser className='ml' data-toggle="collapse" data-target=".navbar-collapse.in" />
            </ul>
          </div>
        </Container>
      </Navbar>
    </Row>
  )
}

export default Navmenu;
